import { CssBaseline, ThemeProvider, useMediaQuery } from "@mui/material";
import { useMemo, type ReactNode } from "react";

import { useUiStore } from "@/lib/uiStore";

import { darkTheme, lightTheme } from "./muiTheme";

// 字型走本地檔案，不依賴 Google Fonts CDN（內部系統不該假設有外網）。
// Roboto 沒有中日韓字符，所以中文一定要有 Noto Sans TC 接在後面。
// 600 是 typeScale 給標籤與按鈕用的字重；兩套字型都有真正的 600 字面，
// 少 import 這一份的話瀏覽器會合成假粗體，中文尤其糊。
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/600.css";
import "@fontsource/roboto/700.css";
import "@fontsource/noto-sans-tc/400.css";
import "@fontsource/noto-sans-tc/500.css";
import "@fontsource/noto-sans-tc/600.css";
import "@fontsource/noto-sans-tc/700.css";

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const mode = useUiStore((state) => state.themeMode);
  const prefersDark = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = useMemo(() => {
    const resolved = mode === "system" ? (prefersDark ? "dark" : "light") : mode;
    return resolved === "dark" ? darkTheme : lightTheme;
  }, [mode, prefersDark]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
}
